import needLogin from './needLogin';

const importedRules = {
  needLogin,
};

/**
 * Check rules,
 * if a rule is failed, an error will be thrown and its accompanied side effect
 */
export default (rules) => {
  const checkers = rules
    .map(rule => importedRules[rule])
    .filter(checker => typeof checker === 'function')
    .map(checker => checker());
  return Promise.all(checkers);
};
